import React, { Component } from "react";
import { getAllCountries, postCountry } from "../../Path/Path";
import { withRouter } from "../../components/withRouter";
import { toast } from "react-toastify"
import Loader from "../../components/Loader";
import { Autocomplete, TextField } from '@mui/material'
import BackButton from "../../components/BackButton";

class AddCountries extends Component {
    constructor(props) {
        super(props)
        this.state = {
            countryName: "",
            countryCode: "",
            prefix: "",
            status: "",
            loading: false,
            countryData: [],
        }
    }
    async componentDidMount() {
        const data = await getAllCountries()
        this.setState({countryData: data.data?.data})
        if (this.props.location.state?.item) {
            const item = this.props.location.state.item
            this.setState({
                countryName: item?.name,
                countryCode: item?.code,
                prefix: item?.prefix,
            })
        }
    }

validator = () => {
    const { countryCode, prefix } = this.state;
    const code = countryCode.toLowerCase();
    const lowerPrefix = prefix.toLowerCase();
    
    if (lowerPrefix === code && lowerPrefix !== "" && lowerPrefix !== null) {
        toast.warn("Country code and Prefix should be unique");
        return false; 
    }
    return true; 
};

sendHandler = async () => {
    try {
        const { countryName, countryCode, prefix } = this.state;

        if (!this.validator()) {
            return; 
        }

        if (!countryName) {
            toast.warn("Select Country Name");
            return;
        }
        if (!countryCode) {
            toast.warn("Enter Country Code");
            return;
        }
        if (!/^[A-Za-z]+$/.test(countryCode)) {
            toast.warn("Country Code must contain only letters");
            return;
        }
        if (!prefix) {
            toast.warn("Enter Country Prefix");
            return;
        }
        if (!/^[A-Za-z0-9]+$/.test(prefix)) {
            toast.warn("Country Prefix must be alphanumeric (letters and numbers only)");
            return;
        }

        const params = {
            name: countryName,
            code: countryCode,
            prefix: prefix,
        };

        if (this.props.location?.state?.item?.name) {
            await postCountry(params);
            toast.success("Country edited successfully");
            this.props.history("/countries");
        } else {
            this.setState({ loading: true });
            const res = await postCountry(params);
            this.setState({ loading: false });

            if (res?.success === false) {
                toast.warn(res?.error);
                return;
            }
            if (res?.error) {
                toast.warn("Something went wrong");
            } else {
                toast.success("Country added successfully");
                this.props.history("/countries");
            }
        }
    } catch (error) {
        toast.error(error?.response?.data?.error || "Something went wrong");
        this.setState({ loading: false });
    }
};

    render() {

        const { countryCode, prefix } = this.state
        const editMode = !!this.props.location?.state?.item

        return (
            <>
                <Loader loading={this.state.loading} />
                <div className="dashboard-main">
                    <div className="dashboard-top">
                        <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
                            <BackButton />
                            <p className="stock-count" style={{ margin: 0 }}>{editMode ? "Edit Country Prefix" : "Add Country Prefix"}</p>
                        </div>
                    </div>
                    <div style={{ paddingInline: 20, marginTop: 20, display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}>
                       <Autocomplete
                            disablePortal
                            id="combo-box-demo"
                            size="small"
                            value={this.state.countryName}
                            options={Array.isArray(this.state.countryData) ? (
                                this.state.countryData
                                    .map((item) => item?.name) 
                                    .reduce((noDupArr, entry) => {
                                        if (noDupArr?.includes(entry)) {
                                            return noDupArr;
                                        } else {
                                            return [...noDupArr, entry]; 
                                        }
                                    }, [])
                                    .filter((item) => item !== null && item !== undefined) 
                            ) : []} 
                            onChange={(e, v) => this.setState({ countryName: v === null ? '' : v })}
                            sx={{ width: 235 }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Country Name"
                                />
                            )}
                        />
                        <TextField
                            sx={{ width: 235 }}
                            defaultValue={this.state.countryCode}
                            value={countryCode}
                            inputProps={{ maxLength: 10 }}
                            placeholder="Country Code"
                            size={'small'}
                            onChange={(e) => {
                                // Convert to uppercase and allow only letters
                                const value = e.target.value
                                    .replace(/[^A-Za-z0-9]/g, '');
                                this.setState({ countryCode: value });
                            }} 
                            id="outlined-basic" 
                            label="Country Code" 
                            variant="outlined" 
                        />
                        <TextField
                            sx={{ width: 235 }}
                            defaultValue={this.state.prefix}
                            value={prefix}
                            inputProps={{ maxLength: 10 }}
                            placeholder="Prefix"
                            size={'small'}
                            onChange={(e) => {
                                // Allow only numbers
                                const value = e.target.value.replace(/[^0-9A-Za-z]/g, '');
                                this.setState({ prefix: value });
                            }} 
                            id="outlined-basic" 
                            label="Prefix" 
                            variant="outlined" 
                        />
                    </div>
                    <div style={{ paddingLeft: 20, marginTop: 20, marginBottom: 20 }} >
                        <button className="run-btn" onClick={() => this.sendHandler()}><p className="run-text">{editMode ? "Edit Country" : "Add Country"}</p></button>
                    </div>
                </div>

            </>
        )
    }
}

export default withRouter(AddCountries);